module.exports = __webpack_public_path__ + "static/media/flag-us.4b2bc4af.webp";